var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExclamationMark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 46,
    viewBox: "0 0 48 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H47.106V35.408H0V0Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.48407 33.1959L4.42578 45.2088L26.5561 32.5635L9.48407 33.1959Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5471 21.3789C21.5471 22.4247 22.4096 23.2126 23.5522 23.2126C24.517 23.2126 25.558 22.512 25.558 21.3789C25.558 19.162 25.6453 16.6888 25.7294 14.2973C25.8143 11.8987 25.9016 9.41833 25.9016 7.18555C25.9016 5.8573 24.9138 4.89404 23.553 4.89404C22.17 4.89404 21.2043 5.83588 21.2043 7.18555C21.2043 9.41833 21.2916 11.8987 21.3757 14.2973C21.4598 16.6888 21.5471 19.162 21.5471 21.3789Z",
    fill: "#5B6075"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5814 25.3882C22.1595 25.3882 21.0034 26.5443 21.0034 27.9661C21.0034 29.3713 22.1595 30.5155 23.5814 30.5155C24.9477 30.5155 26.1022 29.3475 26.1022 27.9661C26.1022 26.5443 24.9715 25.3882 23.5814 25.3882Z",
    fill: "#5B6075"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExclamationMark);
export default __webpack_public_path__ + "static/media/exclamation-mark.71357b6f6d8ed50c27409b3eec7d037a.svg";
export { ForwardRef as ReactComponent };